module.exports = __webpack_public_path__ + "static/img/guoxiang_wang.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wmm/guoxiang_wang.jpg
// module id = E+bb
// module chunks = 0